// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"493":"photoGallery","5757":"fileGallery","6180":"video","6216":"container","9517":"calendar"}[chunkId] || chunkId) + "." + {"493":"fa1505e7","5757":"8ac2456e","6180":"06ae22b4","6216":"5087211b","7495":"240ab03c","9083":"d5a205fb","9517":"9ea643cc"}[chunkId] + ".chunk.css";
};